<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" :layer="layer">
      <template #top v-if="isKomadresVisible">
        <sidebar-row v-if="isFetched" class="mt-5 pb-2 pr-8" border-bottom>
          <v-card class="komadres" max-height="200px" flat>
            <v-timeline class="pt-0" align-top dense>
              <v-timeline-item v-for="(el, idx) in computedHistory" :key="idx" class="text-left pb-4" icon="mdi-check">
                <v-row class="flex-column pl-2" no-gutters>
                  <v-col>
                    <v-card-text class="font-weight-medium pa-0">
                      {{ el.user }}, {{ el.date }}
                      <span style="color: rgba(0,0,0,0.7)" class="text-caption">{{ el.diff }}</span>
                    </v-card-text>
                  </v-col>
                  <v-col>
                    <v-card-text style="color: rgba(0,0,0,0.7)" class="text-caption font-italic pa-0">
                      {{ el.type }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-card>
        </sidebar-row>
        <main-loader v-else class="pt-10" />
      </template>
    </feature-card-basic>
  </v-row>
</template>

<script>
import { get, call } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import SidebarRow from '@/components/SidebarRow';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'FeatureCardKomadres',
  components: {
    FeatureCardBasic,
    SidebarRow,
    MainLoader,
  },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isFetched: false,
    history: [],
  }),
  computed: {
    isSuperAdminEnabled: get('admin/additionalModules@KOMADRES_ORDERS.enabled'),
    isAdminEnabled: get('admin/settingsValues@komadres_orders_module_enabled'),
    modulesPermission: get('users/toolsPermissions@KOMADRES_ORDERS.main_value'),
    currentFeatureId() {
      return this.$route?.params?.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    isKomadresVisible() {
      return (
        this.isSuperAdminEnabled &&
        this.isAdminEnabled &&
        this.modulesPermission &&
        !this.isNew &&
        this.history.length > 0
      );
    },
    computedHistory() {
      return this.history.map(el => {
        return {
          date: this.formatDate(el.data),
          diff: this.getTimeDiff(el.data),
          type: el.opis,
          user: el.kod_uzytkownika,
        };
      });
    },
  },
  watch: {
    currentFeatureId: {
      immediate: true,
      handler(nV) {
        if (nV || nV === 0) {
          this.getKomadresHistory();
        }
      },
    },
  },
  methods: {
    getKomadresOrderHistory: call('externalSystems/getKomadresOrderHistory'),
    async getKomadresHistory() {
      if (this.isNew) {
        return;
      }
      this.isFetched = false;
      this.history = await this.getKomadresOrderHistory(this.currentFeatureId);
      this.isFetched = true;
    },
    formatDate(date) {
      return this.$dayjs(date).format('YYYY-MM-DD HH:mm');
    },
    getTimeDiff(date) {
      const diff = this.$dayjs().diff(this.$dayjs(date));
      const dayString =
        this.$dayjs.duration(diff).days() + ` ${this.$i18n.tc('default.days', this.$dayjs.duration(diff).days())}`;
      const hourString =
        this.$dayjs.duration(diff).hours() + ` ${this.$i18n.tc('default.hours', this.$dayjs.duration(diff).hours())}`;
      const minuteString =
        this.$dayjs.duration(diff).minutes() +
        ` ${this.$i18n.tc('default.minutes', this.$dayjs.duration(diff).minutes())}`;
      const timeArray = [
        ...(this.$dayjs.duration(diff).days() === 0 ? [] : [dayString]),
        ...(this.$dayjs.duration(diff).hours() === 0 ? [] : [hourString]),
        ...(this.$dayjs.duration(diff).minutes() === 0 ? [] : [minuteString]),
      ];
      const timeString = timeArray.join(', ');
      return timeString === '' ? '' : ` (+${timeString})`;
    },
  },
};
</script>

<style lang="scss">
.komadres {
  overflow: auto;
  .v-timeline:before {
    left: 18px !important;
    height: calc(100% - 58px);
  }
  .v-timeline-item__body {
    max-width: 100% !important;
  }
  .v-timeline-item__divider {
    justify-content: start !important;
    min-width: 0 !important;
  }
}
</style>
